var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetDisableIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#a9a9a9;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-973 -462)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(973 462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1,4V7.723H4.723",
    transform: "translate(974.175 462.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.723,17.723V14H17",
    transform: "translate(968.102 458.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.092,6.723A5.584,5.584,0,0,0,3.879,4.639L1,7.344M14.65,9.826l-2.879,2.705a5.584,5.584,0,0,1-9.214-2.085",
    transform: "translate(974.175 462.415)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetDisableIcon);
export default __webpack_public_path__ + "static/media/reset-disable-icon.2fc280790184a03b0ded0b686cf4f367.svg";
export { ForwardRef as ReactComponent };